// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3493a39","732":"db184392","977":"d036584a"}[chunkId] + ".chunk.js";
};